/** Server-projected text candidates. Wording matches are not semantic agreement or purchasing prevalence. */
import * as z from 'zod';
import { resultQuoteSchema } from './shopify-study-results-source.js';
const text = z.string();
const count = z.strictObject({ label: text, detail: text });
const categorySchema = z.strictObject({
    id: text,
    title: text,
    description: text,
    countsHeading: text,
    counts: z.array(count),
    shownLabel: text,
    related: z
        .strictObject({
        heading: text,
        description: text,
        shownLabel: text,
        answers: z.array(resultQuoteSchema.options[0]),
    })
        .optional(),
    passages: z.array(z.strictObject({
        id: text,
        title: text,
        explanation: text,
        answer: resultQuoteSchema.options[0],
    })),
});
export const resultCodebookSchema = z.strictObject({
    scanId: text,
    status: z.enum(['complete', 'partial']),
    heading: text,
    description: text,
    notices: z.array(text),
    coverageHeading: text,
    morePassagesLabel: text,
    coverage: z.array(count),
    categories: z.array(categorySchema),
    otherCategoriesHeading: text,
    otherCategories: z.array(categorySchema),
    unreviewed: z.strictObject({ heading: text, detail: text }),
});
//# sourceMappingURL=response-codebook.js.map